import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Bridal Services',
    path: '/bridal-services'
  }, {
    name: 'Beauty Services',
    path: '/beauty-services'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isSolid = isScrolled || mobileMenuOpen;
  return <>
      <header className={twMerge('fixed top-0 left-0 w-full z-50 transition-all duration-500 ease-soft', isSolid ? 'bg-ivory py-4 shadow-sm' : 'bg-transparent py-6')} data-id="element-39">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-40">
          {/* Logo */}
          <Link to="/" className="flex items-center group" aria-label="Aura Beauty Atelier home" data-id="element-41">
            <img src="https://cdn.magicpatterns.com/uploads/3pmJ4uZByd7icewUvhuvcC/logo_1234.png" alt="Aura Beauty Atelier" className={twMerge('h-32 md:h-40 w-auto transition-all duration-500', isSolid ? 'mix-blend-multiply' : 'invert mix-blend-screen')} data-id="element-42" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-43">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={twMerge('text-sm tracking-widest uppercase transition-colors duration-300 hover:opacity-70', isSolid ? 'text-espresso' : 'text-ivory')} data-id="element-44">
                {link.name}
              </Link>)}
            <Link to="/contact" className={twMerge('ml-4 px-6 py-2.5 text-xs tracking-widest uppercase border transition-all duration-300', isSolid ? 'border-espresso text-espresso hover:bg-espresso hover:text-ivory' : 'border-ivory text-ivory hover:bg-ivory hover:text-espresso')} data-id="element-45">
              Inquire
            </Link>
          </nav>

          {/* Mobile Toggle */}
          <button className="lg:hidden p-2 -mr-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-46">
            {mobileMenuOpen ? <X className={twMerge('w-6 h-6', isSolid ? 'text-espresso' : 'text-ivory')} data-id="element-47" /> : <Menu className={twMerge('w-6 h-6', isSolid ? 'text-espresso' : 'text-ivory')} data-id="element-48" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-49">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="fixed inset-0 z-40 bg-ivory pt-32 px-6 pb-12 flex flex-col" data-id="element-50">
            <nav className="flex flex-col items-center gap-8 mt-12" data-id="element-51">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="text-2xl font-serif text-espresso hover:text-taupe transition-colors" data-id="element-52">
                  {link.name}
                </Link>)}
              <div className="w-12 h-[1px] bg-gold/30 my-4" data-id="element-53" />
              <Link to="/contact" className="px-8 py-3 bg-espresso text-ivory text-sm tracking-widest uppercase" data-id="element-54">
                Inquire to Book
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}